// import React from 'react';
// import { Helmet } from 'react-helmet';
// import coding from '../../../assets/services-pages/coding.mp4';
// import webApp from '../../../assets/services-pages/webApp.png';
// import './web-dev.css';

// function WebDevelopment() {
//     const word = "together";
//     const letters = word.split("");
//     console.log(letters);

//     return (
//         <>
//             <Helmet>
//                 <title>Web Development Services | ERA Automation & Software</title>
//                 <meta
//                     name="description"
//                     content="Our web development services deliver responsive, user-friendly websites built to boost your online presence. We offer web portal and web application development solutions."
//                 />
//                 <meta
//                     name="keywords"
//                     content="web development services, custom web development, responsive web design, website development, web application development, front-end development, back-end development, full-stack web development, e-commerce web development, web portal development"
//                 />
//             </Helmet>

//             <div className='web-dev-wrap'>
//                 {/* Banner Section */}
//                 <div className="bg-white text-black w-screen h-screen  p-10 banner-wrap">
//                     <div className="flex justify-start items-center text-center p-8 banner1">
//                         <h1 className="text-5xl sm:text-7xl md:text-7xl uppercase font-extrabold leading-normal">
//                             web <br /> development
//                         </h1>
//                     </div>
//                     <div className="flex justify-center items-center banner2">
//                         <div className="relative z-10 text-black pr-8">
//                             <h1 className="text-4xl sm:text-6xl md:text-6xl uppercase leading-relaxed">
//                                 it's not just a <span className="font-semibold">fantasy</span>, it's the <span className="font-semibold">future</span> we're crafting{' '}
//                                 <span className="inline-flex items-center">
//                                     {letters.map((letter, index) => (
//                                         <span key={index} className="text-5xl sm:text-7xl md:text-7xl font-extrabold bg-white text-black border border-x-2 border-black p-2 px-3 together">
//                                             {letter}
//                                         </span>
//                                     ))}
//                                 </span>
//                             </h1>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Introduction Section */}
//                 <div className="bg-black text-white w-full p-10 intro">
//                     <div className="flex justify-center items-center p-10">
//                         <p className="text-center text-2xl sm:text-3xl md:w-2/3 py-20 ">
//                             ERA Automation & Software, we are dedicated to delivering high-quality web development services that drive business growth.
//                             Our expertise in web portal development and web application development ensures we provide scalable, efficient, and user-centric
//                             solutions for businesses across various industries.
//                         </p>
//                     </div>

//                     {/* Web Portal Development Section */}
//                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-10 portal-dev ">
//                         <div className="p-10 ">
//                             <h1 className="font-extrabold text-2xl sm:text-4xl md:text-5xl uppercase py-6 text-gray-400">Web Portal Development</h1>
//                             <p className="text-xl leading-normal text-justify indent-4">
//                                 Our web portal development services are designed to create seamless digital experiences for businesses and their customers.
//                                 Whether you're looking for a client portal, employee portal, or a business-to-business (B2B) web portal, we specialize
//                                 in creating secure and customizable solutions that cater to your specific needs.
//                             </p>
//                             <br />
//                             <p className="text-xl leading-normal text-justify indent-4">
//                                 We focus on providing a user-friendly interface, easy integration with third-party systems, and the best performance standards.
//                                 By combining advanced technologies like React, Node.js, and MongoDB, we ensure that your web portal is not only functional
//                                 but also scalable and ready to handle future growth.
//                             </p>
//                             <br />
//                         </div>

//                         {/* Video Section */}
//                         <div className="flex justify-center items-center p-8">
//                             <video autoPlay loop muted playsInline className="w-full max-w-xl">
//                                 <source src={coding} type="video/mp4" />
//                             </video>
//                         </div>
//                     </div>

//                     {/* Benefits Section */}
//                     <div className="text-center py-20">
//                         <h1 className="font-extrabold text-2xl sm:text-4xl md:text-5xl uppercase text-gray-400">Benefits of Our Web Portal Solutions:</h1>
//                         <ul className="list-disc list-inside leading-normal text-xl text-center p-4">
//                             <li className="leading-relaxed">
//                                 <span className="font-bold">Customizable Dashboards: </span>Tailor user experiences with personalized dashboards.
//                             </li>
//                             <li className="leading-relaxed">
//                                 <span className="font-bold">Enhanced User Engagement: </span>Offer a rich user interface and smooth navigation.
//                             </li>
//                             <li className="leading-relaxed">
//                                 <span className="font-bold">Secure Access:</span> Protect sensitive data with the latest security protocols.
//                             </li>
//                         </ul>
//                     </div>
//                 </div>

//                 {/* Web Application Development Section */}
//                 <div className="w-full h-full p-10 development-part">
//                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-10 app-dev">
//                         <div className="p-10">
//                             <h1 className="font-extrabold text-2xl sm:text-4xl md:text-5xl uppercase py-6">Web Application Development</h1>
//                             <p className="text-xl leading-normal text-justify indent-4">
//                                 Our web application development services focus on building fast, reliable, and secure web applications that provide real-time interactions
//                                 and rich user experiences. From single-page applications (SPAs) to complex enterprise applications, our team can develop custom web apps that meet your business requirements.
//                             </p>
//                             <br />
//                             <p className="text-xl leading-normal text-justify indent-4">
//                                 We utilize technologies like React, JavaScript, and Tailwind CSS to create modern, responsive web applications that function seamlessly on any device. Our approach ensures
//                                 that your web apps are optimized for performance, security, and scalability.
//                             </p>
//                             <br />
//                             <p className="text-xl leading-normal text-justify indent-4">
//                                 Whether you're launching a social media app, e-commerce platform, or a data-driven web application, we provide solutions that are secure, high-performing, and easy to maintain.
//                             </p>
//                         </div>

//                         {/* Image Section */}
//                         <div className="flex justify-center items-center p-8">
//                             <img src={webApp} alt="webapp" className="w-full max-w-xl" />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default WebDevelopment;



import React from 'react';
import { Helmet } from 'react-helmet';
import coding from '../../../assets/services-pages/coding.mp4';
import webApp from '../../../assets/services-pages/webApp.png';
import './web-dev.css';

function WebDevelopment() {
    const word = "together";
    const letters = word.split("");
    console.log(letters);

    return (
        <>
            <Helmet>
                <title>Web Development Services | ERA Automation & Software</title>
                <meta
                    name="description"
                    content="Our web development services deliver responsive, user-friendly websites built to boost your online presence. We offer web portal and web application development solutions."
                />
                <meta
                    name="keywords"
                    content="web development services, custom web development, responsive web design, website development, web application development, front-end development, back-end development, full-stack web development, e-commerce web development, web portal development"
                />
            </Helmet>

            <div className='web-dev-wrap'>
                {/* Banner Section */}
                <div className="bg-white text-black w-screen h-screen  p-10 banner-wrap">
                    <div className="flex justify-start items-center text-center p-8 banner1">
                        <h1 className="text-5xl  uppercase font-extrabold leading-normal">
                            web <br /> development
                        </h1>
                    </div>
                    <div className="flex justify-center items-center banner2">
                        <div className="relative z-10 text-black pr-8">
                            <h1 className="text-4xl  uppercase leading-relaxed">
                                it's not just a <span className="font-semibold">fantasy</span>, it's the <span className="font-semibold">future</span> we're crafting{' '}
                                <span className="inline-flex items-center">
                                    {letters.map((letter, index) => (
                                        <span key={index} className="text-5xl font-extrabold bg-white text-black border border-x-2 border-black p-2 px-3 together">
                                            {letter}
                                        </span>
                                    ))}
                                </span>
                            </h1>
                        </div>
                    </div>
                </div>

                {/* Introduction Section */}
                <div className="bg-black text-white w-full p-10 intro">
                    <div className="flex justify-center items-center p-10">
                        <p className="text-center text-2xl  py-20 ">
                            ERA Automation & Software, we are dedicated to delivering high-quality web development services that drive business growth.
                            Our expertise in web portal development and web application development ensures we provide scalable, efficient, and user-centric
                            solutions for businesses across various industries.
                        </p>
                    </div>

                    {/* Web Portal Development Section */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-10 portal-dev ">
                        <div className="p-10 ">
                            <h1 className="font-extrabold text-2xl uppercase py-6 text-gray-400">Web Portal Development</h1>
                            <p className="text-xl leading-normal text-justify indent-4">
                                Our web portal development services are designed to create seamless digital experiences for businesses and their customers.
                                Whether you're looking for a client portal, employee portal, or a business-to-business (B2B) web portal, we specialize
                                in creating secure and customizable solutions that cater to your specific needs.
                            </p>
                            <br />
                            <p className="text-xl leading-normal text-justify indent-4">
                                We focus on providing a user-friendly interface, easy integration with third-party systems, and the best performance standards.
                                By combining advanced technologies like React, Node.js, and MongoDB, we ensure that your web portal is not only functional
                                but also scalable and ready to handle future growth.
                            </p>
                            <br />
                        </div>

                        {/* Video Section */}
                        <div className="flex justify-center items-center p-8">
                            <video autoPlay loop muted playsInline className="w-full max-w-xl">
                                <source src={coding} type="video/mp4" />
                            </video>
                        </div>
                    </div>

                    {/* Benefits Section */}
                    <div className="text-center py-20">
                        <h1 className="font-extrabold text-2xl uppercase text-gray-400">Benefits of Our Web Portal Solutions:</h1>
                        <ul className="list-disc list-inside leading-normal text-xl text-center p-4">
                            <li className="leading-relaxed">
                                <span className="font-bold">Customizable Dashboards: </span>Tailor user experiences with personalized dashboards.
                            </li>
                            <li className="leading-relaxed">
                                <span className="font-bold">Enhanced User Engagement: </span>Offer a rich user interface and smooth navigation.
                            </li>
                            <li className="leading-relaxed">
                                <span className="font-bold">Secure Access:</span> Protect sensitive data with the latest security protocols.
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Web Application Development Section */}
                <div className="w-full h-full p-10 development-part">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-10 app-dev">
                        <div className="p-10">
                            <h1 className="font-extrabold text-2xl  uppercase py-6">Web Application Development</h1>
                            <p className="text-xl leading-normal text-justify indent-4">
                                Our web application development services focus on building fast, reliable, and secure web applications that provide real-time interactions
                                and rich user experiences. From single-page applications (SPAs) to complex enterprise applications, our team can develop custom web apps that meet your business requirements.
                            </p>
                            <br />
                            <p className="text-xl leading-normal text-justify indent-4">
                                We utilize technologies like React, JavaScript, and Tailwind CSS to create modern, responsive web applications that function seamlessly on any device. Our approach ensures
                                that your web apps are optimized for performance, security, and scalability.
                            </p>
                            <br />
                            <p className="text-xl leading-normal text-justify indent-4">
                                Whether you're launching a social media app, e-commerce platform, or a data-driven web application, we provide solutions that are secure, high-performing, and easy to maintain.
                            </p>
                        </div>

                        {/* Image Section */}
                        <div className="flex justify-center items-center p-8">
                            <img src={webApp} alt="webapp" className="w-full max-w-xl" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WebDevelopment;
